import { render, staticRenderFns } from "./publish.vue?vue&type=template&id=1583d78f&scoped=true"
import script from "./publish.vue?vue&type=script&lang=js"
export * from "./publish.vue?vue&type=script&lang=js"
import style0 from "./publish.vue?vue&type=style&index=0&id=1583d78f&prod&lang=scss&scoped=true"
import style1 from "./publish.vue?vue&type=style&index=1&id=1583d78f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1583d78f",
  null
  
)

export default component.exports